import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchCatalog, fetchWishlist, addToWishlist, removeFromWishlist } from '../api/wishlist';

export function useCatalog() {
  return useQuery({ queryKey: ['steam-catalog'], queryFn: fetchCatalog });
}

export function useWishlist() {
  return useQuery({ queryKey: ['wishlist'], queryFn: fetchWishlist });
}

export function useAddToWishlist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (appid: number) => addToWishlist(appid),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['wishlist'] }),
  });
}

export function useRemoveFromWishlist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (appid: number) => removeFromWishlist(appid),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['wishlist'] }),
  });
}
